export default __webpack_public_path__ + "static/media/16.5a3a747e.jpg";